var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal-message',{ref:"modalMessage",staticClass:"modal-select-chart",attrs:{"eventSubmit":_vm.eventSubmit},scopedSlots:_vm._u([{key:"message",fn:function(){return [_c('div',{staticClass:"align-center"},[_vm._v("本日の通常学習は終了です！")])]},proxy:true},{key:"buttonLabel",fn:function(){return [_vm._v("確認")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }